class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange);
  }

  onStickyVariantChange() {
    this.varOptions = this.querySelector("select");
    //console.log("connected", this.varOptions.value);

    let productForms = document.querySelector(
      `#product-sticky-form-${this.dataset.section}`
    );
    let input = productForms.querySelector('input[name="id"]');
    input.value = this.varOptions.value;
  }
}
customElements.define("sticky-variant-select", StickyProVariantSelect);

let stickySelectedVariant = document.querySelector(`#sticky__variant`);
if (stickySelectedVariant) {
  let stickySelectVairantInput = document.querySelector(
    "#sticky__selected_variant_id"
  );
  stickySelectVairantInput.value = stickySelectedVariant.value;
}

const BuyButtonForm = document.querySelector(".product_buy_button_form");
const productStickyWrapper = document.querySelector(".product__sticky");

// Below 750px the sticky bar is forced visible via CSS (always shown), so we
// skip the scroll-based toggle entirely on mobile — it would be redundant
// and could fight with the CSS !important rules.
function isMobileViewport() {
  return window.innerWidth < 750;
}

window.addEventListener("scroll", function () {
  if (isMobileViewport()) return;

  if (!productStickyWrapper) return;

  if (BuyButtonForm) {
    let BuyBUttonOffset = TopOffset(BuyButtonForm);
    let BuyBUttonTopffset = BuyBUttonOffset.top;

    if (window.scrollY > BuyBUttonTopffset) {
      productStickyWrapper.classList.add("sticky");
      document.body.classList.add("sticky__cart");
    } else {
      productStickyWrapper.classList.remove("sticky");
      document.body.classList.remove("sticky__cart");
    }
  } else {
    // Fallback: .product_buy_button_form wasn't found on this page, so we
    // can't measure its offset. Show the sticky bar once the user has
    // scrolled a bit, instead of never showing it at all.
    if (window.scrollY > 400) {
      productStickyWrapper.classList.add("sticky");
      document.body.classList.add("sticky__cart");
    } else {
      productStickyWrapper.classList.remove("sticky");
      document.body.classList.remove("sticky__cart");
    }
  }
});

if (!BuyButtonForm && productStickyWrapper) {
  console.warn(
    '[product-sticky-cart] ".product_buy_button_form" not found on this page — desktop scroll behavior falls back to a fixed 400px threshold. Add that class to your main Add to Cart form to restore the original offset-based behavior.'
  );
}